import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export const Footer = ({ compact = false }) => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10">
    <div className={`mx-auto max-w-[1400px] px-5 sm:px-8 ${compact ? "pt-4 pb-10" : "pt-24 pb-28 lg:pb-10"}`}>
      {!compact && (
      <Reveal>
        <button data-testid="footer-cta-btn" onClick={() => scrollToId("pool-check")} className="group block text-left">
          <span className="block font-display text-[14vw] lg:text-[9rem] font-semibold leading-[0.9] tracking-[-0.04em]">
            Bereit für <span className="text-[var(--lagoon)] font-accent">Saison zwei?</span>
          </span>
          <span className="mt-6 inline-flex items-center gap-2 text-lg text-[var(--mist)] group-hover:text-[var(--foam)] transition-colors">
            Pool-Check starten <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
          </span>
        </button>
      </Reveal>
      )}
      <div className={`grid gap-10 pt-10 sm:grid-cols-3 ${compact ? "" : "mt-20 border-t border-white/10"}`}>
        <div>
          <Logo testId="footer-logo" href={compact ? "/" : "#top"} />
          <p className="mt-4 text-sm text-[var(--mist)]">the coolpool company GmbH<br />Wasser und Technik perfekt vereint!</p>
        </div>
        <div className="text-sm text-[var(--mist)] space-y-1" data-testid="footer-contact">
          <p className="text-[var(--foam)]">Kontakt</p>
          <p>Auf'm Reck 65<br />33334 Gütersloh</p>
          <a href="tel:+491751600677" data-testid="footer-phone-link" className="block hover:text-[var(--foam)] transition-colors">0175 1600677</a>
          <a href="mailto:info@cool-pool-company.de" data-testid="footer-email-link" className="block hover:text-[var(--foam)] transition-colors">info@cool-pool-company.de</a>
          <a href="https://cool-pool-company.de/" target="_blank" rel="noopener noreferrer" data-testid="footer-website-link" className="link-underline text-[var(--foam)]">cool-pool-company.de</a>
        </div>
        <div className="flex flex-col gap-1 text-sm text-[var(--mist)]">
          <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[var(--foam)] transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[var(--foam)] transition-colors">Datenschutz</Link>
          <p className="mt-4">© {new Date().getFullYear()} the coolpool company GmbH</p>
        </div>
      </div>
    </div>
  </footer>
);
